import { render } from "./BooksAndCourses.vue?vue&type=template&id=3263e23e&scoped=true"
import script from "./BooksAndCourses.vue?vue&type=script&lang=js"
export * from "./BooksAndCourses.vue?vue&type=script&lang=js"

import "./BooksAndCourses.vue?vue&type=style&index=0&id=3263e23e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3263e23e"]])

export default __exports__